import { filterCountryFull } from "@/helpers/filteCountry";
import { CountryData } from "@/types/CountryType";
import { ref, Ref } from "vue";

export const useDialCodeSelector = (countries: Ref<CountryData[]>) => {
  const countriesOptions = ref<CountryData[]>(countries.value);

  function onFilterCountry(query: string) {
    countriesOptions.value = countries.value.filter((country) => {
      return filterCountryFull(country, query);
    });
  }

  return {
    countriesOptions,
    onFilterCountry
  };
};
